import React, { useState, useEffect } from "react";
import { Popover, Button, Slider, Col, Row, Typography, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { themeCreateAction } from "../../../store/action/admin/themeActions";
import { TranslatorCompanyTag } from "../../../languageTranslator/LanguageTranslatorTags";
import MoonIcon from "../../../Theme/CustomIcons/Icons/Weather/MoonIcon";
import SunIcon from "../../../Theme/CustomIcons/Icons/Weather/SunIcon";
import ClockIcon from "../../../Theme/CustomIcons/Icons/Time/ClockIcon";
import { langaugeTanslatorAction } from "../../../store/action/admin/languageTranslatorActions";
import { css } from "@emotion/css";
import { antSwitch } from "./theme";

import { generate } from "@ant-design/colors";
import MaxIcon from "../../../Theme/CustomIcons/Icons/CustomIcons/MaxIcon";
const { Option } = Select;
const { Text, Title } = Typography;
const colorMode = [
  {
    id: "purple",
    icon: <MaxIcon size="large" style={{ fontSize: "24px" }} />,
    label: <TranslatorCompanyTag>Max</TranslatorCompanyTag>,
    color: "#f0f0f0",
  },
  {
    id: "dark",
    icon: <MoonIcon />,
    label: <TranslatorCompanyTag>Dark</TranslatorCompanyTag>,
    color: "black",
  },
  {
    id: "default",
    icon: <SunIcon />,
    label: <TranslatorCompanyTag>Light</TranslatorCompanyTag>,
    color: "#260b3b",
  },
];
const MaxThemeDark = [
  { id: "1", name: "Lime", color: "#DBFF00" },
  { id: "2", name: "Lemon", color: "#FDFF8A" },
  { id: "3", name: "Mint", color: "#CCFFB2" },
  { id: "4", name: "Turquoise", color: "#6AFFA6" },
  { id: "5", name: "Frost", color: "#B2FFFF" },
  { id: "6", name: "Aqua", color: "#58FFEB" },
  { id: "7", name: "Periwinkle", color: "#B2C1FF" },
  { id: "8", name: "Lavender", color: "#DDB2FF" },
  { id: "9", name: "Blush", color: "#FFB2DC" },
];

const MaxThemeLight = [
  { id: "1", name: "Blue", color: "#2F54EB" },
  { id: "2", name: "Turquoise", color: "#13C2C2" },
  { id: "3", name: "Lime", color: "#37A800" },
  { id: "4", name: "Coral", color: "#FA8C16" },
  { id: "5", name: "Pink", color: "#EB2F96" },
  { id: "6", name: "Plum", color: "#260B3B" },
  { id: "7", name: "Violet", color: "#8459FF" },
  { id: "8", name: "Orange", color: "#F16444" },
  { id: "9", name: "Crimson", color: "#F5222D" },
];
const MaxThemeMax = [{ id: "1", name: "Peach", color: "#F7C2A5" }];
const ThemeSettingsPopup = (props) => {
  const dispatch = useDispatch();
  const themeDefault = useSelector((state) => state.themeDefault);
  const themeCreateList = useSelector((state) => state.themeCreateList);
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const [themeId, setThemeId] = useState(themeDefault?.info?.themeColor);
  const [primaryColor, setPrimaryColor] = useState(
    themeDefault?.info?.colorPrimary || MaxThemeLight[0].color
  );
  const mapBorderRadiusForBackend = (value) => {
    switch (value) {
      case 0:
        return 4;
      case 4:
        return 8;
      case 8:
        return 16;
      case 12:
        return 32;
      default:
        return value; // Fallback to the original value if it's out of the expected range
    }
  };
  const decodeBorderRadiusFromBackend = (value) => {
    switch (value) {
      case "4":
        return 0;
      case "8":
        return 4;
      case "16":
        return 8;
      case "32":
        return 12;
      default:
        return value; // Fallback to the original value if it's out of the expected range
    }
  };

  const [borderRadius, setBorderRadius] = useState(0);
  const [language, setLanguage] = useState(themeDefault?.info?.language);
  const [newConfig, setNewConfig] = useState({});

  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [MaxTheme, setMaxTheme] = useState(MaxThemeLight);

  useEffect(() => {
    let MaxTheme =
      themeId === "dark"
        ? MaxThemeDark
        : themeId === "purple"
        ? MaxThemeMax
        : MaxThemeLight;
    setMaxTheme(MaxTheme);
    setThemeId(themeDefault?.info?.themeColor || "");
    setLanguage(themeDefault?.info?.language || "");
    setPrimaryColor(themeDefault?.info?.colorPrimary || "");
    setBorderRadius(
      decodeBorderRadiusFromBackend(themeDefault?.info?.borderRadius)
    );
  }, [themeDefault, props.viewThemeSettings]);
  const handleLanguageChange = (value) => {
    setLanguage(value);
    setIsSaveDisabled(false);
  };

  const handleThemeChange = (themeId) => {
    setThemeId(themeId);
    setIsSaveDisabled(false);
    let MaxTheme =
      themeId === "dark"
        ? MaxThemeDark
        : themeId === "purple"
        ? MaxThemeMax
        : MaxThemeLight;
    setMaxTheme(MaxTheme);
    let colorPrimary =
      themeId === "purple"
        ? MaxThemeMax[0].color
        : themeId === "dark"
        ? MaxThemeDark[0].color
        : themeId === "default" && MaxThemeLight[0].color;
    setPrimaryColor(colorPrimary);
  };

  const handleThemeColorChange = (colorPrimary) => {
    setPrimaryColor(colorPrimary);
    setIsSaveDisabled(false);
  };

  const handleThemeBorderChange = (borderRadius) => {
    setBorderRadius(borderRadius);
    setIsSaveDisabled(false);
  };

  const generateNewConfig = () => {
    const newConfig = antSwitch(
      themeId,
      primaryColor,
      language || themeDefault?.info?.language || "en",
      themeDefault?.info?.borderRadius || "8"
    );
    setNewConfig(newConfig);
  };

  useEffect(() => {
    generateNewConfig();
  }, [themeId, primaryColor, themeDefault]);

  const { translations } = getLanguageTranslatorList;
  const handleSave = async () => {
    const mappedBorderRadius = mapBorderRadiusForBackend(borderRadius);
    let colorPrimary =
      themeDefault?.info?.themeColor === themeId
        ? primaryColor
        : themeId === "purple"
        ? "#FFBB96"
        : themeId === "dark"
        ? "#DBFF00"
        : themeId === "default" && "#F16444";
    await dispatch(
      themeCreateAction({
        themeColor: themeId,
        colorPrimary: primaryColor,
        borderRadius: mappedBorderRadius,
        language: language,
        newConfig: newConfig,
      })
    );
    setIsSaveDisabled(true);

    if (getLanguageTranslatorList?.translations?.title !== language) {
      await dispatch(langaugeTanslatorAction(language));
    }
  };

  return (
    <Row
      className={css`
        padding: 15px 20px;
        textalign: ${translations?.direction === "rtl" ? "right" : "left"};
      `}
    >
      {" "}
      <Col span={24}>
        <Row
          style={{
            marginBottom: "10px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Col
            span={24}
            style={{ display: "flex" }}
            className={css`
              textalign: ${translations?.direction === "rtl"
                ? "right"
                : "left"};
            `}
          >
            <p className={"theme-title-font"}>Max Themes</p>
          </Col>
          <Col
            span={24}
            style={{ display: "flex" }}
            className={css`
              textalign: ${translations?.direction === "rtl"
                ? "right"
                : "left"};
            `}
          >
            <p style={{ color: "grey", fontSize: "10px" }}>
              Choose if Max's appearances should be dark, light, or Max-themed
            </p>
          </Col>
        </Row>
      </Col>
      <Col span={24} style={{ marginBottom: "15px" }}>
        <Row
          gutter={[8, 8]}
          className={css`
            display: flex;
            // gap: 10px;
          `}
        >
          {colorMode.map((theme) => {
            let selected = themeId === theme.id;
            return (
              <Col span={8} key={theme.id}>
                <div
                  onClick={() => handleThemeChange(theme.id)}
                  style={{
                    display: "flex",
                    // padding: "0px 5px",
                    gap: "10px",
                    height: "45px",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: `${themeDefault?.info?.borderRadius}px`,
                  }}
                  className={css`
                    transition: border 0.3s ease-in-out,
                      background-color 0.3s ease-in-out, color 0.3s ease-in-out;
                    color: ${selected
                      ? themeDefault?.info.newConfig?.colorTextSecondary
                      : themeDefault?.info.newConfig?.color};
                    .ant-typography {
                      transition: color 0.3s ease-in-out;
                      color: ${selected
                        ? themeDefault?.info.newConfig?.colorTextSecondary
                        : themeDefault?.info.newConfig?.color};
                    }
                    background-color: ${selected
                      ? `${themeDefault?.info?.colorPrimary}`
                      : "transparent"};
                    border: ${selected
                      ? `1px solid ${themeDefault?.info?.colorPrimary}`
                      : `1px solid ${themeDefault?.info.newConfig?.borderColor}`};
                    &:hover {
                      color: ${selected
                        ? themeDefault?.info.newConfig?.colorTextSecondary
                        : themeDefault?.info?.colorPrimary};
                      // background-color: ${themeDefault?.info.newConfig
                        ?.colorPrimary};
                      border: 1px solid ${themeDefault?.info?.colorPrimary};
                      .ant-typography {
                        color: ${selected
                          ? themeDefault?.info.newConfig?.colorTextSecondary
                          : themeDefault?.info?.colorPrimary};
                      }
                    }
                  `}
                >
                  <div>{theme.icon}</div>
                  <Text>{theme.label}</Text>
                </div>
              </Col>
            );
          })}
        </Row>
      </Col>{" "}
      <Col
        span={24}
        style={{ display: "flex", marginBottom: "10px" }}
        className={css`
          textalign: ${translations?.direction === "rtl" ? "right" : "left"};
        `}
      >
        <p className={"theme-title-font"}>Color Mode</p>{" "}
      </Col>
      <Col span={24} style={{ marginBottom: "15px" }}>
        <Row
          gutter={[8, 8]}
          className={css`
            display: flex;
            // gap: 10px;
          `}
        >
          {MaxTheme.map((theme) => {
            let selected = primaryColor === theme.color;
            let btnStyle = css`
              cursor: pointer;
              transition: border 0.3s ease-in-out;
              border: ${selected
                ? `1px solid ${theme.color}`
                : `1px solid ${themeDefault?.info.newConfig?.borderColor}`};
              color: ${selected
                ? primaryColor
                : themeDefault?.info.newConfig?.color};
              .ant-typography {
                transition: color 0.3s ease-in-out;
                color: ${selected
                  ? primaryColor
                  : themeDefault?.info.newConfig?.color};
              }

              &:hover {
                color: ${selected
                  ? themeDefault?.info.newConfig?.color
                  : theme.color};
                border: 1px solid ${theme.color};
                .ant-typography {
                  color: ${theme.color};
                }
              }
            `;
            let colorshades = generate(theme.color);
            return (
              <Col span={8} key={theme.id}>
                <div
                  style={{
                    display: "flex",
                    padding: "0px 10px",
                    gap: "5px",
                    height: "45px",
                    alignItems: "center",
                    // justifyContent: "center",
                    borderRadius: `${themeDefault?.info?.borderRadius}px`,
                  }}
                  className={
                    themeId === "purple"
                      ? css`
                          cursor: not-allowed;
                          border: 1px solid
                            ${themeDefault?.info.newConfig?.borderColor};
                        `
                      : btnStyle
                  }
                  onClick={() => {
                    if (themeId != "purple") {
                      handleThemeColorChange(theme.color, themeId);
                    }
                    // setThemeColor(theme.color);
                  }}
                >
                  <span
                    key={theme.name}
                    className={css`
                      background: linear-gradient(
                        200deg,
                        ${colorshades[4]},
                        ${colorshades[5]},
                        ${colorshades[7]}
                      ) !important;
                    `}
                    style={{
                      width: "30px",
                      height: "30px",
                      // backgroundColor: theme.color,
                      borderRadius: "50px",
                    }}
                  />
                  <Text
                    style={{
                      textAlign:
                        translations?.direction === "rtl" ? "right" : "left",
                    }}
                  >
                    {theme.name}
                  </Text>
                </div>
              </Col>
            );
          })}
        </Row>
      </Col>
      <Col span={24}>
        <Row
          className={css`
            display: flex;
            flex-direction: column;
            gap: 10px;
          `}
        >
          <Col
            span={24}
            style={{ marginBottom: "10px", display: "flex" }}
            className={css`
              textalign: ${translations?.direction === "rtl"
                ? "right"
                : "left"};
            `}
          >
            <p className={"theme-title-font"}>Border Radius</p>
          </Col>
          <Col span={24}>
            <Slider
              className={css`
                margin: 0px 10px;
                margin-bottom: 40px;
                width: 90%;
              `}
              min={0}
              max={12}
              value={borderRadius}
              onChange={(value) => {
                handleThemeBorderChange(value);
              }}
              step={4}
              marks={{
                0: "Sharp",
                4: "Slightly Rounded",
                8: "Smooth",
                12: "Rounded",
              }}
              tooltip={{ formatter: null }}
            />
          </Col>{" "}
          {/* <Col span={24} style={{ marginBottom: "10px" }}>
            <TranslatorCompanyTag>Language Changer</TranslatorCompanyTag>
          </Col> */}
        </Row>
      </Col>{" "}
      <Col
        span={24}
        style={{ display: "flex" }}
        className={css`
          display: flex;
          textalign: ${translations?.direction === "rtl" ? "right" : "left"};
        `}
      >
        {/* <Select value={language} onChange={handleLanguageChange}>
              <Option value="en">English</Option>
              <Option value="ar">Arabic</Option>
            </Select> */}
        <Button
          type="primary"
          loading={
            themeCreateList?.loading || getLanguageTranslatorList?.loading
          }
          disabled={
            isSaveDisabled ||
            themeCreateList?.loading ||
            getLanguageTranslatorList?.loading
          }
          onClick={handleSave}
        >
          Update Theme
        </Button>
      </Col>
    </Row>
  );
};

export default ThemeSettingsPopup;
